import { showToast, toastQueue } from "@certn/cascadia/components/toast/utils";
import {
  ToastContext,
  ToastSettings,
} from "@certn/cascadia/context/ToastContext";
import { useToastQueue } from "@react-stately/toast";
import { PropsWithChildren } from "react";
import { createPortal } from "react-dom";

import { ToastRegion } from "./ToastRegion";

export function ToastProvider(props: PropsWithChildren) {
  const { children } = props;

  const state = useToastQueue(toastQueue);

  /** @deprecated use showToast directly instead */
  function show(toast: ToastSettings) {
    showToast(toast.title, { type: toast.type });
  }

  /** @deprecated */
  function close(id: string | undefined) {
    if (id) {
      toastQueue.close(id);
    }
  }

  return (
    <ToastContext.Provider value={{ show, close }}>
      {children}
      {state.visibleToasts.length > 0 &&
        createPortal(<ToastRegion {...props} state={state} />, document.body)}
    </ToastContext.Provider>
  );
}
